import axios from "axios";
import { getToken, baseUrl } from "./baseUrl";

const FetchData = async ({ endPoint }) => {
  console.log("entered");
  try {
    const response = await axios.get(`${baseUrl}${endPoint}`, {
      headers: {
        tymeplusjwt: getToken(), // read the token fresh on every call
      },
    });
    console.log("response-->", response);
    return response.data;
  }
catch (error) {
  console.error("error---->", error);

  if (
    process.env.NODE_ENV === "development" &&
    error.response?.status === 400 &&
    error.response?.data === "Invalid token"
  ) {
    localStorage.removeItem("token");
    console.warn("Development token is invalid. Please log in again.");
  }

  throw error;
}
};

export default FetchData;